import React from "react"
import EmptyButton from "components/EmptyButton"
import img from "../../images/emptyquestions.svg"
import { woopraTrack } from "../../utils/woopra/woopraTracker"

const EmptyQuestions = (props) => (
  <div className="empty-container">
    <img src={img} />
    <span className="empty-container-title">
      No hay preguntas para mostrar.
    </span>
    <span>
      Comienza a crear las preguntas directamente desde la plataforma o mediante
      nuestro importable de excel.
    </span>
    <div className="empty-container-buttons">
      <EmptyButton
        size="large"
        label="+ Nueva pregunta"
        loading={false}
        onClick={() => {
          woopraTrack("Nueva Pregunta Cuestionario")
          props.getQuestionTypesWatcher(props.match.params.id)
          props.getQuestionSuccess({})
          props.toggleDrawer("questionsDrawer", true)
        }}
      />
      <EmptyButton
        size="large"
        label="Importar cuestionario"
        loading={false}
        onClick={() => {
          woopraTrack("Importar cuestionario")
          props.url()
        }}
      />
    </div>
  </div>
)

export default EmptyQuestions
